import { render, staticRenderFns } from "./commercialAdminManage.vue?vue&type=template&id=71df74d8"
import script from "./commercialAdminManage.vue?vue&type=script&lang=js"
export * from "./commercialAdminManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports